
import { defineComponent } from "vue";
export default defineComponent({
  name: "404NotFound",
});
